module.exports = __webpack_public_path__ + "static/media/l12_voice_one_v2.a7b8a186.mp3";